import React, { useEffect } from 'react';
import {
  CrossDeleteIcon,
  CrossDeleteIconDisable,
} from '../../../../img/findcare/FindCareSVG';

const LocationViewListItem = ({
  location,
  onDeleteClick,
  showDelete,
  editAffiliatedRecords,
}) => {
  useEffect(() => {
    console.log('bbb eee eee lll lll rendered');
  }, []);
  return (
    <div className="location-container">
      <div>
        <span className="location">
          <span className="location-name">{location.LocationName}</span>
          {showDelete ? (
            editAffiliatedRecords ? (
              <span className="cross-delete-icon" onClick={onDeleteClick}>
                <CrossDeleteIcon />
              </span>
            ) : (
              <span className="cross-delete-icon">
                <CrossDeleteIconDisable />
              </span>
            )
          ) : null}
        </span>
      </div>
    </div>
  );
};

export default React.memo(LocationViewListItem);
